module.exports = __webpack_public_path__ + "static/img/2.bd2bf49.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/eng/2.png
// module id = WFTv
// module chunks = 0